export interface IWatrViewerDocument {
    docType: number;
    lookupId: number;
    label: string;
}
